
import { PostList } from '../features/blog/components/PostList/PostList';

export const BlogPage = () => <PostList />;
